import React from 'react';
import { cn } from '../utils';
export function Button({
  children,
  className,
  variant = 'primary',
  size = 'lg',
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
}) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-[background-color,transform,box-shadow] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-cream-50';
  const variants = {
    primary: 'bg-rose-600 hover:bg-rose-700 text-white shadow-[0_14px_30px_-14px_rgba(157,79,112,0.55)] focus-visible:ring-rose-500',
    outline: 'border-2 border-rose-600 text-rose-700 hover:bg-rose-50 focus-visible:ring-rose-500'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3.5 text-[15px]',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  return <button className={cn(baseStyles, variants[variant], sizes[size], className)} {...props} data-id="element-244" data-mp="x4fq2rq61v22">
      {children}
    </button>;
}
export function Badge({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <span className={cn('inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-white text-ink border border-rose-200', className)} data-id="element-245" data-mp="17350y0jnaf8t">
      {children}
    </span>;
}